export const getAllNotifications = async (token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch('https://makegayfriends.com/api/v1/notifications', { headers });
    const data = await response.json();
    return data
}

export const getNotificationMarker = async (token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch('https://makegayfriends.com/api/v1/markers?timeline[]=notifications', { headers });
    const data = await response.json();
    return data
}

export const setNotificationMarker = async (token, lastReadId) => {
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
    const body = { notifications: { last_read_id: lastReadId } }
    const response = await fetch('https://makegayfriends.com/api/v1/markers', { method: "POST", headers, body: JSON.stringify(body) });
    const data = await response.json();
    return data
}

export const dismissNotification = async (id, token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch('https://makegayfriends.com/api/v1/notifications/'+id+'/dismiss', { method: "POST", headers });
    const data = await response.json();
    return data
}

export const clearNotifications = async (token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch('https://makegayfriends.com/api/v1/notifications/clear', { method: "POST", headers });
    const data = await response.json();
    return data
}

let api = process.env.REACT_APP_MKGF_MASTODON_API+'/user'

export const updateLocation = async ({token, mastodon_id, latitude, longitude}) => {
    let body = { mastodon_id, location: { type: 'Point', coordinates: [longitude, latitude] } }
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
    const response = await fetch( api+'/', { method:"POST", headers, body:JSON.stringify(body) });
    const data = await response.json();
    return data
}

// Never sends the actual location anywhere new — this only flips the server
// flag that gates whether the location LocationTracker already keeps fresh
// may be used to show an "in person" badge on Mingle/check-ins.
export const updateShareInPersonStatus = async ({token, mastodon_id, share_in_person_status}) => {
    let body = { mastodon_id, share_in_person_status }
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
    const response = await fetch( api+'/', { method:"POST", headers, body:JSON.stringify(body) });
    const data = await response.json();
    return data
}